
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-secrets/no-secrets */
import { Loader, useModal } from '@jutro/components';
import { IntlContext, useTranslator } from '@jutro/locale';
import { MetadataForm } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
// import { getNormalizedLOBName } from '@xengage/gw-portals-config-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import {  
    PaymentMethod,
    MakeAPayment,
    SetupAutomaticPaymentComponent
} from 'ent-capability-billing-react';

import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {    useCallback,    useContext,    useEffect,    useMemo,    useState} from 'react';
import PaymentHistory from '../PaymentHistory/PaymentHistory';
import messages from './BillingSummary.messages';
import metadata from './BillingSummary.metadata.json5';
import styles from './BillingSummary.module.scss';

const getInvoicesByTerm = ((invoiceSummary, termNumber) => {
    let returnInvoices;

    if (!_.isEmpty(termNumber.toString().toLowerCase())){
        if (termNumber.toString().toLowerCase() === 'all'){
            returnInvoices = invoiceSummary;
        } else {
            returnInvoices =  _.filter(invoiceSummary, item => item.policyPeriodTerm_TWIA === termNumber.toString());
        }
    }
    return returnInvoices;
});

const getAnyPaidInvoices = invoiceSummary => _.filter(invoiceSummary, item => 
        // We only show fully paid invoices in the paid filter section as per requirements.
        // const { amount } = item.totalPaid;
         item.paidStatus === 'fullypaid' // || amount !== 0;
    );

const getUnpaidInvoices = invoiceSummary => _.filter(invoiceSummary, item => item.paidStatus !== 'fullypaid');

const hasUnpaidInvoices = invoiceSummary => {
    const unpaidInvoices = getUnpaidInvoices(invoiceSummary);
    return unpaidInvoices.length > 0;
};

function BillingSummary(props) {
    const { showAlert } = useModal();

    const {
        invoiceStream,
        accountNumber,
        invoiceStreamId,
        selectedInvoicesForPaymentFromACI,
        lobCode,
        paymentGroupDetails,
        currency,
        selectSubMenu,
        authHeader,
        reloadInvoiceDetails,
        onResolve,
        onReject,
        onAfterClose,
        history,
        scrollToHistorySection,
        paymentInstruments,
        // tokenFromACI
    } = props;

    const intl = useContext(IntlContext);
    const translator = useTranslator();

    const { AccountBillingDetailsService: BillingService } = useDependencies(
        'AccountBillingDetailsService'
    );
    // screen states
    const [isLoadingData, updateIsLoadingData] = useState(false);
    const [selectedInvoicesForPayment, updateSelectedInvoicesForPayment] =  useState([]);
    const [selectedInvoiceFilter, updateSelectedInvoiceFilter] =        useState('planned');
    const [selectedScreen, updateSelectedScreen] = useState('default');
    const [manualAmountToPay, updateManualAmount] = useState(null);
    const [selectedInvoiceAmount, updateSelectedInvoiceAmount] = useState(0);
    const [billingData, setBillingData] = useState([]);
    const [termNumber, setTermNumber] = useState('');
    const [policyPeriodDropDownOptions, setPolicyPeriodDropDownOptions] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState('');
    const [paymentPlan, setPaymentPlan] = useState('');
    // lift the states from payment component class - move them to billing summary
    const [selectedPaymentInstrumentId, setSelectedPaymentInstrumentId] = useState('');
    const [selectedPaymentInstrument, setSelectedPaymentInstrument] = useState({});
    const [isAutoDraft, setIsAutoDraft] = useState(false);
    const payingAmountValue = manualAmountToPay ? manualAmountToPay.amount : 0;
    const {
        invoiceSummary = [],
        relatedPolicies = [],
        paymentInstrument,
        periodicity,
    } = paymentGroupDetails;

    const getInvoiceStreamHeader = () => {
        let header = '';
        header =   isAutoDraft ? translator(messages.viewInvoicesWithAutoPayEnabled) : translator(messages.viewInvoices);
        return header;
    };

    const getPaymentHeader = () => {
        let paymentHeader = '';
        paymentHeader =   isAutoDraft ? translator(messages.selectInvoicesToPayWithAutoPayEnabled) : translator(messages.selectInvoicesToPay);
        return paymentHeader;
    }
    
    const onSelectedInstrumentChange = useCallback((value) => {
        setSelectedPaymentInstrumentId(value);
        const instrument = paymentInstruments.find(pi => pi.publicID === value);
        setSelectedPaymentInstrument(instrument);
    },  [ paymentInstruments]);

    const setPaymentInstrument = useCallback((instrument) => {
        setSelectedPaymentInstrumentId(instrument.publicID);
        setSelectedPaymentInstrument(instrument);
       
    },  [setSelectedPaymentInstrument]);

    const firstInvoiceDueDate = useMemo(() => {
        const unPaidInvoices = _.filter(invoiceSummary, invoice => invoice.paidStatus !== 'paid');

        const firstUnpaidInvoice = _.minBy(unPaidInvoices, invoice => new Date(invoice.dueDate).getTime());

        return firstUnpaidInvoice ? firstUnpaidInvoice.dueDate : null;
    }, [invoiceSummary]);


    const resetInternalStates = useCallback(() => {
        updateIsLoadingData(true);
        reloadInvoiceDetails(invoiceStreamId, true).finally(() => {
            updateSelectedInvoicesForPayment([]);
            updateSelectedInvoiceFilter('planned');
            updateManualAmount(null);
            updateIsLoadingData(false);
        });
    }, [reloadInvoiceDetails, invoiceStreamId]);


    const onClickCancelMakePayment = useCallback(() => {
        updateSelectedScreen();
    }, []);

    const onClickConfirmSetupAutomaticPayment = useCallback(
        (paymentDetailsVm, paymentMethod) => {
            const paymentDetailsValue = paymentDetailsVm.value;

            const bankAccountData = {
                ...paymentDetailsValue,
            };

            const creditCardData = {
                ...paymentDetailsValue,
            };

            let detailsValue;

            if (paymentMethod === 'wire') {
                detailsValue = { bankAccountData };
            } else {
                detailsValue = { creditCardData };
            }

            const paymentInstrumentValue = {
                paymentMethod,
                ...detailsValue,
            };

            BillingService.setPaymentGroupPaymentInformation(
                invoiceStreamId,
                paymentInstrumentValue,
                authHeader
            )
                .then(() => {
                    updateSelectedScreen('automaticConfirmation');
                })
                .catch(() => {
                    showAlert({
                        title: messages.accountUpdateFailed,
                        message:
                            messages.sorryWeWereNotAbleToSetupAutomaticPaymentsOnYourAccount,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).then(() => {
                        resetInternalStates();
                    }, _.noop);
                });
        },
        [BillingService, invoiceStreamId, authHeader, showAlert, resetInternalStates]
    );

    const onClickCancelSetupAutomaticPayment = useCallback(() => {
        updateSelectedScreen();
    }, []);


    const onClickCancelChangePaymentSource = useCallback(() => {
        updateSelectedScreen();
    }, []);

    function isOverDue(invoiceItem) {
        const currDate  = moment();
        if (!_.isEmpty(invoiceItem)) {
            const itemDate = moment(invoiceItem.dueDate);
            return invoiceItem.paidStatus === 'unpaid' && itemDate.isBefore(currDate, 'day');
        }
        return false;
    };

    // include logic for preselected invoices...
    const onUpdateSelectedInvoices = useCallback(
        selectedInvoiceSummariesId => {
           
            const overdueInvoices = _.filter( invoiceSummary,  anInvoiceSummary =>  isOverDue(anInvoiceSummary));

            if (!_.isEmpty(overdueInvoices)){
                overdueInvoices.forEach((inv) => {
                    selectedInvoiceSummariesId.push(inv.invoiceId);
                })
            }
             
            const selectedInvoiceObjects = _.filter( invoiceSummary,
                 anInvoiceSummary => selectedInvoiceSummariesId.includes(anInvoiceSummary.invoiceId) );
                
            const selectedTotalAmount = _.sumBy(
                selectedInvoiceObjects,
                invoice => Number(_.get(invoice, 'amountDue.amount'))
            ).toFixed(2);

            updateSelectedInvoiceAmount(selectedTotalAmount);
            
            const amountObject = {
                amount: selectedTotalAmount,
                currency,
            };

            updateManualAmount(amountObject);
            updateSelectedInvoicesForPayment(selectedInvoiceSummariesId);
        },
        [invoiceSummary, currency]
    );

    const goToHistorySection = useCallback(() => {
        const data = document.getElementById('paymentHistoryContainer');

        data.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        })


    }, []);

  
    const onClickMenuLink = useCallback(
        evt => {
            const { id: menuLinkId } = evt.currentTarget;
            let screen;

            if(menuLinkId === 'viewPaymentHistoryLinkId'){
                goToHistorySection();
                return; 
            }

            switch (menuLinkId) {
                case 'makeAPaymentLinkId':
                    screen = 'payment';
                    break;
                case 'setupAutomaticPaymentsLinkId':
                    screen = 'automatic';
                    break;
                case 'changePaymentMethodLinkId':
                    screen = 'automatic'; // points to automatic
                    break;
                case 'viewInvoicesLinkId':
                case 'default':
                    screen = 'default';
                    break;
                default:
                    screen = 'default';
                    resetInternalStates();
                    break;
            }
            updateSelectedScreen(screen);
        },
        [goToHistorySection, resetInternalStates]
    );

    const onClickFilterChange = useCallback(value => {
        updateSelectedInvoiceFilter(value);
    }, []);

    const isAmountToPayValid = useCallback(
        amount => (
                selectedInvoiceAmount < amount ||
                amount === 0 ||
                _.isNull(amount)
            ),
        [selectedInvoiceAmount]
    );

    const getPolicyPeriodDropDownOptions = useCallback((bd) => {
        
        if (_.isEmpty(bd)){
            return null;
        }

        const now = moment();
        const dropDownPolicyData = bd.map((key) => {
            let policyPeriodName = `${key.periodNameWithTerm_TWIA}`;

            if (key.effectiveDate && now.isAfter(key.effectiveDate)
                && key.expirationDate && now.isBefore(key.expirationDate) && (!key.isCanceled_Ext)
            ) {
                policyPeriodName = `${policyPeriodName}  ${translator( messages.current )}`;
            }
            else {
                policyPeriodName = `${policyPeriodName}`;
            }

            return {
                code: key.periodNameWithTerm_TWIA,
                name: policyPeriodName,
            };
        });

            return [...dropDownPolicyData, { code: 'all', name: translator(messages.policyPeriodAll) }]

    }, [translator]);

    
    const getPolicyBillingSummaryInfo = useCallback(async (policyNumber) => {
        await BillingService.getPolicyBillingSummaryInfo(
            policyNumber,
            authHeader
        ).then((billingResponseData = {}) => {
            if ( !_.isUndefined(billingResponseData.policyPeriodBillingSummaries)) {               
                const bd = billingResponseData.policyPeriodBillingSummaries;
                const policyPeriodDropdownData = getPolicyPeriodDropDownOptions(bd);
                setPolicyPeriodDropDownOptions(policyPeriodDropdownData);
                // setSelectedPeriod(bd[0].periodNameWithTerm_TWIA);
                // always set to current period the first time.. you land on the screen
                let currPeriod = policyPeriodDropdownData.find((f) => f.name.toLowerCase().includes('current'))
                if(!currPeriod){
                    // eslint-disable-next-line prefer-destructuring
                    currPeriod = policyPeriodDropdownData[0]
                }
                const findBd = bd.find((i) => currPeriod.name.includes(i.periodName));
                setSelectedPeriod(findBd.periodNameWithTerm_TWIA);
                setPaymentPlan(findBd.paymentPlan);
                setTermNumber(findBd.termNumber_TWIA);
                setIsAutoDraft(findBd.isAutoDraft_TWIA)
                setBillingData(bd);
                if(scrollToHistorySection) {
                    goToHistorySection();
                }
            }

        });
    }, [BillingService, authHeader, getPolicyPeriodDropDownOptions, goToHistorySection, scrollToHistorySection]);

    const handlePolicyPeriodChange = useCallback((policyPeriod) => {
        const policyChangeData = billingData.find(data => data.periodNameWithTerm_TWIA === policyPeriod);

        setSelectedPeriod(policyPeriod);
        
        if (policyChangeData){
            setSelectedPeriod(policyChangeData.periodNameWithTerm_TWIA);
            setTermNumber(policyChangeData.termNumber_TWIA);
            setPaymentPlan(policyChangeData.paymentPlan);
            setIsAutoDraft(policyChangeData.isAutoDraft_TWIA);
        } else {
            setTermNumber('All');
        }
    }, [billingData]);

    function getTotalInvoiceAmount(id) {
        const summaries = getUnpaidInvoices(getInvoicesByTerm(invoiceSummary, termNumber));
        return _.sum(summaries.filter(inv => inv.invoiceId === id).map(inv=> inv.amountDue.amount));
    }

    function getTotalInvoiceDueAmount(id) {
        const summaries = getUnpaidInvoices(getInvoicesByTerm(invoiceSummary, termNumber));
        return _.sum(summaries.filter(inv => inv.invoiceId === id && inv.invoiceStatus === 'due').map(inv=> inv.amountDue.amount));
    }

    const originalPaymentAmounts = (() => {
        let totalAmount=0.00;
        const uniqueInvoices = [...new Set(selectedInvoicesForPayment)];

        uniqueInvoices.forEach((item) => {
            // get the original amount due value...
            totalAmount += getTotalInvoiceAmount(item);
        });
        
        return totalAmount;
    });

    const originalPaymentDueAmounts = (() => {
        let totalAmount=0.00;
        const uniqueInvoices = [...new Set(selectedInvoicesForPayment)];
        uniqueInvoices.forEach((item) => {
            // get the original amount due value...
            totalAmount += getTotalInvoiceDueAmount(item);
        });
         
        return totalAmount;
    });

    useEffect(() => {
            if (!_.isEmpty(relatedPolicies[0]) && _.isEmpty(billingData)){
                getPolicyBillingSummaryInfo(relatedPolicies[0]);
            }        
            const defaultFilter = hasUnpaidInvoices(invoiceSummary)?'planned': 'paid';
            updateSelectedInvoiceFilter(defaultFilter);  
            // land on the sreen redirected from ACI.
            if (!_.isEmpty(selectSubMenu)){
                if (selectSubMenu === 'autoPay'){
                    updateSelectedScreen('automatic');
                } else if (selectSubMenu === 'payment'){
                    updateSelectedScreen('payment');
                    // we are redirected with saved selected Invoices prior to navigating to ACI...with state values from ACI...
                    if (!_.isEmpty(selectedInvoicesForPaymentFromACI)){
                        updateSelectedInvoicesForPayment(selectedInvoicesForPaymentFromACI)
                    }
                }
            }
            
            // should we be defaulting to selected value or not? need confirmation...
            // if (!_.isEmpty(tokenFromACI)){
            //     if(relatedPolicies[0] === invoiceStream?.label){
            //         setSelectedPaymentInstrumentId( paymentInstruments?.find((f) => f.token === tokenFromACI)?.publicID);
            //     }           
            //    // onSelectedInstrumentChange(paymentInstruments?.find((f) => f.token === tokenFromACI)?.publicID);
            // }
    }, [accountNumber, billingData, getPolicyBillingSummaryInfo, goToHistorySection, invoiceSummary, paymentInstruments, relatedPolicies, selectSubMenu, selectedInvoicesForPaymentFromACI]);

    if (isLoadingData) {
        return <Loader loaded={!isLoadingData} />;
    }
   
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
            showRequired: true
        },
        validationMessageIfPaymentisMore: {
            content: translator(messages.validationMessageIfPaymentisMore),
            visible:  manualAmountToPay?.amount > originalPaymentAmounts()
        },
        validationMessageIfPaymentisLess: {
            content: translator(messages.validationMessagegIfPaymentIsLess),
            visible:  manualAmountToPay?.amount >= 0 && manualAmountToPay?.amount < originalPaymentDueAmounts()
        },
        menuLinkContainerId: {
            visible:
                (invoiceStreamId) &&
                !(selectedScreen === 'automaticConfirmation'),
        },
        changePaymentMethodLinkId: {
            visible: !!paymentInstrument,
        },
        setUpAutomaticPaymentHeaderId: {
            content: paymentInstrument? messages.editAutoPay: messages.setupAutoPay
        },
        setupAutomaticPaymentsLinkId: {
            visible: !paymentInstrument,
        },
        billingInvoicesContainerId: {
            visible: selectedScreen === 'default' && !!invoiceStreamId,
        },
        billingInvoicesHeaderId: {
            content: getInvoiceStreamHeader(),
            visible: invoiceStreamId 
        },
     
        invoicesFilterToggleId: {
            onValueChange: onClickFilterChange,
        },
        billingInvoicesComponentId: {
            selectedTerm: termNumber,
            invoiceSummary:
                selectedInvoiceFilter === 'planned'
                    ? getUnpaidInvoices(getInvoicesByTerm(invoiceSummary, termNumber))
                    : getAnyPaidInvoices(getInvoicesByTerm(invoiceSummary, termNumber)),
            showPaidDate: selectedInvoiceFilter === 'paid',
        },
        makePaymentContainerId: {
            visible: selectedScreen === 'payment',
        },
        makePaymentInvoicesTableTitleId:{
            content: getPaymentHeader()
        },
        makePaymentInvoicesTableComponentId: {
           
            invoiceSummary: getUnpaidInvoices(getInvoicesByTerm(invoiceSummary, termNumber)),
            selectedInvoices: selectedInvoicesForPayment,
            onUpdateSelectedInvoices,
        },
        
        makePaymentSourceComponentId: {
            title: messages.setPaymentSource,
            xCenter: 'bc',
            model: paymentInstrument,
            isDisabled: selectedInvoicesForPayment.length === 0,
            isSelectedInvoiceAmount: manualAmountToPay && isAmountToPayValid(manualAmountToPay.amount),
        },
        makePaymentAmountToPayId: {
            defaultCurrency: currency,
            disabled: selectedInvoicesForPayment.length === 0,
            visible: getUnpaidInvoices(getInvoicesByTerm(invoiceSummary, termNumber))?.length > 0,
            onValueChange: updateManualAmount,
        },
        makePaymentConfirmationContainerId: {
            visible: selectedScreen === 'paymentConfirmation',
        },
        makePaymentConfirmationMessageId: {
            content: translator(messages.paymentOfHasBeenAppliedToYourAccount, {
                paidAmount: intl.formatNumber(payingAmountValue, {
                    style: 'currency',
                    currency,
                    currencyDisplay: 'code',
                }),
            }),
        },
        setUpAutomaticPaymentContainerId: {
            visible: selectedScreen === 'automatic',
        },
        setupAutomaticPaymentComponentId: {
            xCenter: 'bc',
            model: paymentInstrument,
        },
        setUpAutomaticPaymentConfirmationContainerId: {
            visible: selectedScreen === 'automaticConfirmation',
        },
        setUpAutomaticPaymentConfirmationInfoId: {
            content: translator(messages.yourAutomaticPaymentsWillBeginOn, {
                startingDate: intl.formatDate(new Date(firstInvoiceDueDate), {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                }),
            }),
        },
        changePaymentSourceContainerId: {
            visible: selectedScreen === 'payment-source',
        },
        changePaymentSourceFormComponentId: {
            title: messages.changePaymentMethod,
            xCenter: 'bc',
            model: paymentInstrument,
        },
        changePaymentSourceConfirmationContainerId: {
            visible: selectedScreen === 'paymentSourceConfirmation',
        },
        policyListContainerId: {
            visible: selectedScreen === 'policy-list',
        },
        PaymentHistoryField: {
            termNumber,
            selectedPolicy: relatedPolicies[0],
            authHeader
        },
        policyPeriodDropDown: {
            availableValues: policyPeriodDropDownOptions,
            value: selectedPeriod
        },
        paymentPlanValue: {
            content: paymentPlan
        },
        paymentMethodSectionForAutoPay:{
            payFrom: "autoPay",
            lobCode,
            streamPublicId: invoiceStreamId,
            identifier: relatedPolicies[0],
            accountNumberIdentifier: accountNumber,
            authHeader,
            onSelectedInstrumentChange,
            paymentInstrument: selectedPaymentInstrumentId,
            paymentInstruments,
            selectedPaymentInstrument: setPaymentInstrument,
            isAutoDraft,// this is used to differentiate if autopayEnabled is on or off
            useProfile: true, // useProfile is always true for autopay section
            paymentPlanIn: paymentPlan,
            history
        },
        setupAutoPaySection: {
            payFrom: "autoPay",
            invoiceStream,
            streamPublicId: invoiceStreamId,
            policyNumber: relatedPolicies[0],
            accountNumber,
            authHeader,
            onSelectedInstrumentChange,
            paymentInstrumentId: selectedPaymentInstrumentId,
            paymentInstruments,
            paymentPlanIn: paymentPlan,
            history
        },
        paymentMethodSection: {
            payFrom: "invoices",
            lobCode,
            manualAmountToPay,
            identifier: relatedPolicies[0], // selected Policy
            accountNumberIdentifier: accountNumber, // selected AccountNumber
            authHeader,
            isAutoDraft,
            useProfile: false, // useProfile is always false from invoices/make a payemnt screen
            onSelectedInstrumentChange,
            selectedPaymentInstrument: setPaymentInstrument,
            paymentInstrument: selectedPaymentInstrumentId,
            selectedInvList: selectedInvoicesForPayment,
            paymentInstruments,
            history
        },
         makeAPaymentSection: { 
            payFrom: "invoices",
            policyNumber: relatedPolicies[0],
            authHeader, 
            manualAmountToPay,
            invoiceSummary: getUnpaidInvoices(getInvoicesByTerm(invoiceSummary, termNumber)),
            originalPaymentAmounts: originalPaymentAmounts(),
            originalPaymentDueAmounts: originalPaymentDueAmounts(),
            paymentPlan, 
            calcFees: true,
            isAutoDraft, 
            accountNumberIdentifier: accountNumber,
            identifier: relatedPolicies[0],
            paymentInstrument: selectedPaymentInstrument,
            selectedInvoicesForPayment,
            paymentInstruments,
            currency,
            onResolve,
            onReject,
            onAfterClose,
            onSelectedInstrumentChange,
            history
        },    
    
    };

    const dataForComponent = {
        invoiceStreamId,
        selectedInvoiceFilter,
        periodicity,
        startingDate: firstInvoiceDueDate,
        manualAmountToPay,
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            paymentmethod: PaymentMethod,
            makeapayment: MakeAPayment,
            setupautopay: SetupAutomaticPaymentComponent,
            PaymentHistory
        },
        resolveCallbackMap: {
            onClickMenuLink,
            // onClickConfirmMakePayment,
            onClickCancelMakePayment,
            onClickConfirmSetupAutomaticPayment,
            onClickCancelSetupAutomaticPayment,
            // onClickConfirmChangePaymentSource,
            onClickCancelChangePaymentSource,
            handlePolicyPeriodChange,
           //  getAutoPayData
        },
    };

    return (
        <MetadataForm
            data={dataForComponent}
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            isUsingNewValidation
        />
    );
}

BillingSummary.propTypes = {
    // policyNumber: PropTypes.string,
    accountNumber: PropTypes.string.isRequired,
    invoiceStreamId: PropTypes.string,
    lobCode: PropTypes.string,
    paymentGroupDetails: PropTypes.shape({
        invoiceSummary: PropTypes.array,
        relatedPolicies: PropTypes.array,
        paymentInstrument: PropTypes.object,
        paymentInstrumentSummary: PropTypes.object,
        periodicity: PropTypes.string,
    }),
    currency: PropTypes.string.isRequired,
    authHeader: PropTypes.shape({}).isRequired,
    reloadInvoiceDetails: PropTypes.func.isRequired,
};

BillingSummary.defaultProps = {
    // policyNumber: null,
    accountNumber: null,
    invoiceStreamId: null,
    lobCode: null,
    paymentGroupDetails: {
        invoiceSummary: [],
        relatedPolicies: [],
        paymentInstrument: null,
        paymentInstrumentSummary: null,
        periodicity: null,
    },
    policySummaries: [],
    paymentInstruments: [],
};

export default withAuthenticationContext(BillingSummary);
